import React, { useMemo } from 'react'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { BatteryModel } from 'src/Libs/batteries'
import BatteryOverviewData from 'src/Elements/SystemSettings/Battery/BatteryOverviewData'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'
import SystemStatusIndicator from '../SystemStatusIndicator'
import { getSystemStatusByDeviceState, SystemStatusType } from '../SystemSettingsUtils'

interface Props {
  model: BatteryModel
}

const BatteryOverview: React.FC<Props> = ({ model }) => {
  const { t } = useCustomTranslation()

  const currentBatteryDeviceState = useMemo<SystemStatusType>(() => {
    if (model?.deviceState) {
      return getSystemStatusByDeviceState(model?.deviceState)
    }
    return 'missing'
  }, [model?.deviceState])

  return (
    <Paper
      title={t('systemSettings.battery.overview.sectionTitle')}
      data-qa={'battery-overview'}
      headerChildren={model ? <SystemStatusIndicator status={currentBatteryDeviceState} /> : null}
    >
      {model ? <BatteryOverviewData model={model} /> : <SystemSettingsBlankView />}
    </Paper>
  )
}

export default BatteryOverview
